/* eslint-disable max-len */
import { featuresListByCountryCodeProps } from '@customTypes/PropTypes';

export const europeRegionFeatures: featuresListByCountryCodeProps[] = [
    {
        countryCode: 'GB',
        languagePreference: '',
        featuresList: {
            // Explore D&B tile
            isExploreDNBTileEnabled: true,
            exploreDNBTileURL: 'https://{envPrefix}.dnb.co.uk/solutions/small-business.html?utm_source=dnb_customer_portal&utm_medium=explore_products',
            // Market Place section
            isMarketPlaceSectionEnabled: false,
            marketPlaceSectionURL: '',
            // Company Details
            isAddCompanyCTAEnabled: true,
            addCompanyCTAURL: 'https://{envPrefix}.dnb.co.uk/duns-number/lookup/request-a-duns-number.html',
            isUpdatedInfoCTAEnabled: true,
            updatedInfoCTAURL: 'https://{updateEnvPrefix}.dnb.co.uk/utility-pages/data-update.html',
            isViewPublicProfileCTAEnabled: false,
            viewPublicProfileCTAURL: '',
            // Learning center
            isLearningCenterEnabled: true,
            learningCenterURL: 'https://learning.dnb.co.uk/',
            // Support
            isSupportEnabled: true,
            supportURL: 'https://www.dnb.co.uk/contact-us.html',
            // Cancel renewal
            isCancelRenewalEnabled: true,
            isCancelrenewalSupportThroughEmail: false,
            cancelRenewalURL: 'https://www.dnb.co.uk/contact-us/ecommerce-cancellation-form.html',
            //  Recommended Products
            isRecommendedProductsEnabled: false,
            // Terms of Use
            termsOfUseURL: 'https://www.dnb.co.uk/utility-pages/terms-of-use.html',
            // Privacy Policy
            privacyPolicyURL: 'https://www.dnb.co.uk/utility-pages/privacy-policy.html',
            // Deals and offers
            isDealsOffersEnabled: false,
            // Recommended Service Section
            isRecommendedServiceEnabled: false,
            // My Business Overview Section only for CM UKI
            isBusinessOverviewEnabled: true,
            // Trust Centre link
            trustCentre: 'https://www.dnb.com/about-us/data-transparency.html',
        },
    },
    {
        countryCode: 'IE',
        languagePreference: '',
        featuresList: {
            // Explore D&B tile
            isExploreDNBTileEnabled: true,
            exploreDNBTileURL: 'https://{envPrefix}.dnb.co.uk/solutions/small-business.html?utm_source=dnb_customer_portal&utm_medium=explore_products',
            // Market Place section
            isMarketPlaceSectionEnabled: false,
            marketPlaceSectionURL: '',
            // Company Details
            isAddCompanyCTAEnabled: true,
            addCompanyCTAURL: 'https://{envPrefix}.dnb.co.uk/duns-number/lookup/request-a-duns-number.html',
            isUpdatedInfoCTAEnabled: true,
            updatedInfoCTAURL: 'https://{updateEnvPrefix}.dnb.co.uk/utility-pages/data-update.html',
            isViewPublicProfileCTAEnabled: false,
            viewPublicProfileCTAURL: '',
            // Learning center
            isLearningCenterEnabled: true,
            learningCenterURL: 'https://learning.dnb.co.uk/',
            // Support
            isSupportEnabled: true,
            supportURL: 'https://www.dnb.com/ie/contact-us.html',
            // Cancel renewal
            isCancelRenewalEnabled: true,
            isCancelrenewalSupportThroughEmail: false,
            cancelRenewalURL: 'https://www.dnb.com/ie/contact-us/ecommerce-cancellation-form.html',
            //  Recommended Products
            isRecommendedProductsEnabled: false,
            // Terms of Use
            termsOfUseURL: 'https://www.dnb.com/ie/utility-pages/terms-of-use.html',
            // Privacy Policy
            privacyPolicyURL: 'https://www.dnb.com/ie/utility-pages/privacy-policy.html',
            // Deals and offers
            isDealsOffersEnabled: false,
            // Recommended Service Section
            isRecommendedServiceEnabled: false,
            // My Business Overview Section only for CM UKI
            isBusinessOverviewEnabled: true,
            // Trust Centre link
            trustCentre: 'https://www.dnb.com/about-us/data-transparency.html',
        },
    }, {
        countryCode: 'PL',
        languagePreference: 'en-pl',
        featuresList: {
            // Explore D&B tile
            isExploreDNBTileEnabled: true,
            exploreDNBTileURL: 'https://www.dnb.com/pl-pl/lista-produktow/',
            // Market Place section
            isMarketPlaceSectionEnabled: false,
            marketPlaceSectionURL: '',
            // Company Details
            isAddCompanyCTAEnabled: true,
            addCompanyCTAURL: 'https://www.dnb.com/pl-pl/numer-d-u-n-s-wypelnij-formularz/',
            isUpdatedInfoCTAEnabled: true,
            updatedInfoCTAURL: 'dnbeu-dunshelp.pl@dnb.com',
            isViewPublicProfileCTAEnabled: false,
            viewPublicProfileCTAURL: '',
            // Learning center
            isLearningCenterEnabled: false,
            learningCenterURL: '',
            // Support
            isSupportEnabled: true,
            supportURL: 'https://www.dnb.com/pl-pl/kontakt-i-pomoc/',
            // Cancel renewal
            isCancelRenewalEnabled: true,
            isCancelrenewalSupportThroughEmail: false,
            cancelRenewalURL: 'https://www.dnb.com/pl-pl/kontakt-i-pomoc.html',
            //  Recommended Products
            isRecommendedProductsEnabled: false,
            // Terms of Use
            termsOfUseURL: 'https://www.dnb.com/content/dam/bisnode/international/pdf_docs/Bisnode%20Polska_Regulamin_swiadczenia_uslug_droga_elektroniczna.pdf',
            // Privacy Policy
            privacyPolicyURL: 'https://www.dnb.com/content/dam/bisnode/international/pdf_docs/dun--bradstreet_polityka_prywatnosci_2022_09_05.pdf',
            // Deals and offers
            isDealsOffersEnabled: false,
            // Recommended Service Section
            isRecommendedServiceEnabled: false,
            // My Business Overview Section only for CM UKI
            isBusinessOverviewEnabled: false,
            // Trust Centre link
            trustCentre: 'https://www.dnb.com/about-us/data-transparency.html',
        },
    }, {
        countryCode: 'PL',
        languagePreference: 'pl-pl',
        featuresList: {
            // Explore D&B tile
            isExploreDNBTileEnabled: true,
            exploreDNBTileURL: 'https://www.dnb.com/pl-pl/lista-produktow/',
            // Market Place section
            isMarketPlaceSectionEnabled: false,
            marketPlaceSectionURL: '',
            // Company Details
            isAddCompanyCTAEnabled: true,
            addCompanyCTAURL: 'https://www.dnb.com/pl-pl/numer-d-u-n-s-wypelnij-formularz/',
            isUpdatedInfoCTAEnabled: true,
            updatedInfoCTAURL: 'dnbeu-dunshelp.pl@dnb.com',
            isViewPublicProfileCTAEnabled: false,
            viewPublicProfileCTAURL: '',
            // Learning center
            isLearningCenterEnabled: false,
            learningCenterURL: '',
            // Support
            isSupportEnabled: true,
            supportURL: 'https://www.dnb.com/pl-pl/kontakt-i-pomoc/',
            // Cancel renewal
            isCancelRenewalEnabled: true,
            isCancelrenewalSupportThroughEmail: false,
            cancelRenewalURL: 'https://www.dnb.com/pl-pl/kontakt-i-pomoc.html',
            //  Recommended Products
            isRecommendedProductsEnabled: false,
            // Terms of Use
            termsOfUseURL: 'https://www.dnb.com/content/dam/bisnode/international/pdf_docs/Bisnode%20Polska_Regulamin_swiadczenia_uslug_droga_elektroniczna.pdf',
            // Privacy Policy
            privacyPolicyURL: 'https://www.dnb.com/content/dam/bisnode/international/pdf_docs/dun--bradstreet_polityka_prywatnosci_2022_09_05.pdf',
            // Deals and offers
            isDealsOffersEnabled: false,
            // Recommended Service Section
            isRecommendedServiceEnabled: false,
            // My Business Overview Section only for CM UKI
            isBusinessOverviewEnabled: false,
            // Trust Centre link
            trustCentre: 'https://www.dnb.com/about-us/data-transparency.html',
        },
    }, {
        countryCode: 'CZ',
        languagePreference: '',
        featuresList: {
            // Explore D&B tile
            isExploreDNBTileEnabled: true,
            exploreDNBTileURL: 'https://www.dnb.com/cs-cz/produkty/',
            // Market Place section
            isMarketPlaceSectionEnabled: false,
            marketPlaceSectionURL: '',
            // Company Details
            isAddCompanyCTAEnabled: true,
            addCompanyCTAURL: 'https://www.dnb.com/cs-cz/produkty/',
            isUpdatedInfoCTAEnabled: true,
            updatedInfoCTAURL: 'helpdesk.cz@dnb.com',
            isViewPublicProfileCTAEnabled: false,
            viewPublicProfileCTAURL: '',
            // Learning center
            isLearningCenterEnabled: false,
            learningCenterURL: '',
            // Support
            isSupportEnabled: true,
            supportURL: 'https://www.dnb.com/cs-cz/kontakt/',
            // Cancel renewal
            isCancelRenewalEnabled: true,
            isCancelrenewalSupportThroughEmail: false,
            cancelRenewalURL: 'https://www.dnb.com/cs-cz/kontakt/',
            //  Recommended Products
            isRecommendedProductsEnabled: false,
            // Terms of Use
            termsOfUseURL: 'https://www.dnb.com/cs-cz/podminky/vop/',
            // Privacy Policy
            privacyPolicyURL: 'https://www.dnb.com/cs-cz/privacy/',
            // Deals and offers
            isDealsOffersEnabled: false,
            // Recommended Service Section
            isRecommendedServiceEnabled: false,
            // My Business Overview Section only for CM UKI
            isBusinessOverviewEnabled: false,
            // Trust Centre link
            trustCentre: 'https://www.dnb.com/about-us/data-transparency.html',
        }
    }, {
        countryCode: 'HU',
        languagePreference: 'en-hu',
        featuresList: {
            // Explore D&B tile
            isExploreDNBTileEnabled: true,
            exploreDNBTileURL: 'https://www.dnb.com/hu-hu/bisnode-termekek/',
            // Market Place section
            isMarketPlaceSectionEnabled: false,
            marketPlaceSectionURL: '',
            // Company Details
            isAddCompanyCTAEnabled: true,
            addCompanyCTAURL: 'https://www.dnb.com/hu-hu/szolgaltatasok/dun-and-bradstreet/dnb-duns-szam/dnb-duns-szam-igenyles/',
            isUpdatedInfoCTAEnabled: true,
            updatedInfoCTAURL: 'info.hungary@dnb.com',
            isViewPublicProfileCTAEnabled: false,
            viewPublicProfileCTAURL: '',
            // Learning center
            isLearningCenterEnabled: false,
            learningCenterURL: '',
            // Support
            isSupportEnabled: true,
            supportURL: 'https://www.dnb.com/hu-hu/kapcsolat/',
            // Cancel renewal
            isCancelRenewalEnabled: true,
            isCancelrenewalSupportThroughEmail: false,
            cancelRenewalURL: 'https://www.dnb.com/hu-hu/kapcsolat/',
            //  Recommended Products
            isRecommendedProductsEnabled: false,
            // Terms of Use
            termsOfUseURL: 'https://www.dnb.com/hu-hu/aszf.html',
            // Privacy Policy
            privacyPolicyURL: 'https://www.dnb.com/hu-hu/adatkezelesi-tajekoztato.html',
            // Deals and offers
            isDealsOffersEnabled: false,
            // Recommended Service Section
            isRecommendedServiceEnabled: false,
            // My Business Overview Section only for CM UKI
            isBusinessOverviewEnabled: false,
            // Trust Centre link
            trustCentre: 'https://www.dnb.com/about-us/data-transparency.html',
        }
    }, {
        countryCode: 'HU',
        languagePreference: 'hu-hu',
        featuresList: {
            // Explore D&B tile
            isExploreDNBTileEnabled: true,
            exploreDNBTileURL: 'https://www.dnb.com/hu-hu/bisnode-termekek/',
            // Market Place section
            isMarketPlaceSectionEnabled: false,
            marketPlaceSectionURL: '',
            // Company Details
            isAddCompanyCTAEnabled: true,
            addCompanyCTAURL: 'https://www.dnb.com/hu-hu/szolgaltatasok/dun-and-bradstreet/dnb-duns-szam/dnb-duns-szam-igenyles/',
            isUpdatedInfoCTAEnabled: true,
            updatedInfoCTAURL: 'info.hungary@dnb.com',
            isViewPublicProfileCTAEnabled: false,
            viewPublicProfileCTAURL: '',
            // Learning center
            isLearningCenterEnabled: false,
            learningCenterURL: '',
            // Support
            isSupportEnabled: true,
            supportURL: 'https://www.dnb.com/hu-hu/kapcsolat/',
            // Cancel renewal
            isCancelRenewalEnabled: true,
            isCancelrenewalSupportThroughEmail: false,
            cancelRenewalURL: 'https://www.dnb.com/hu-hu/kapcsolat/',
            //  Recommended Products
            isRecommendedProductsEnabled: false,
            // Terms of Use
            termsOfUseURL: 'https://www.dnb.com/hu-hu/aszf.html',
            // Privacy Policy
            privacyPolicyURL: 'https://www.dnb.com/hu-hu/adatkezelesi-tajekoztato.html',
            // Deals and offers
            isDealsOffersEnabled: false,
            // Recommended Service Section
            isRecommendedServiceEnabled: false,
            // My Business Overview Section only for CM UKI
            isBusinessOverviewEnabled: false,
            // Trust Centre link
            trustCentre: 'https://www.dnb.com/about-us/data-transparency.html',
        }
    }, {
        countryCode: 'CH',
        languagePreference: 'en-ch',
        featuresList: {
            // Explore D&B tile
            isExploreDNBTileEnabled: true,
            exploreDNBTileURL: 'https://www.dnb.com/en-ch/products-services/',
            // Market Place section
            isMarketPlaceSectionEnabled: false,
            marketPlaceSectionURL: '',
            // Company Details
            isAddCompanyCTAEnabled: true,
            addCompanyCTAURL: 'https://www.dnb.com/en-ch/duns-request/',
            isUpdatedInfoCTAEnabled: true,
            updatedInfoCTAURL: 'dnbeu-investigation.ch@dnb.com',
            isViewPublicProfileCTAEnabled: false,
            viewPublicProfileCTAURL: '',
            // Learning center
            isLearningCenterEnabled: false,
            learningCenterURL: '',
            // Support
            isSupportEnabled: true,
            supportURL: 'https://www.dnb.com/en-ch/contact/',
            // Cancel renewal
            isCancelRenewalEnabled: true,
            isCancelrenewalSupportThroughEmail: false,
            cancelRenewalURL: 'https://www.dnb.com/en-ch/about-us/customer-service/',
            //  Recommended Products
            isRecommendedProductsEnabled: false,
            // Terms of Use
            termsOfUseURL: 'https://hello.dnb.com/rs/145-JUC-481/images/GTC-Dun-Bradstreet-Schwitzerland-Ltd_2021-06_EN.pdf',
            // Privacy Policy
            privacyPolicyURL: 'https://www.dnb.com/en-ch/data-privacy/',
            // Deals and offers
            isDealsOffersEnabled: false,
            // Recommended Service Section
            isRecommendedServiceEnabled: false,
            // My Business Overview Section only for CM UKI
            isBusinessOverviewEnabled: false,
            // Trust Centre link
            trustCentre: 'https://www.dnb.com/about-us/data-transparency.html',
        }
    }, {
        countryCode: 'CH',
        languagePreference: 'de-ch',
        featuresList: {
            // Explore D&B tile
            isExploreDNBTileEnabled: true,
            exploreDNBTileURL: 'https://www.dnb.com/de-ch/produkte-services/',
            // Market Place section
            isMarketPlaceSectionEnabled: false,
            marketPlaceSectionURL: '',
            // Company Details
            isAddCompanyCTAEnabled: true,
            addCompanyCTAURL: 'https://www.dnb.com/de-ch/duns-request/',
            isUpdatedInfoCTAEnabled: true,
            updatedInfoCTAURL: 'dnbeu-investigation.ch@dnb.com',
            isViewPublicProfileCTAEnabled: false,
            viewPublicProfileCTAURL: '',
            // Learning center
            isLearningCenterEnabled: false,
            learningCenterURL: '',
            // Support
            isSupportEnabled: true,
            supportURL: 'https://www.dnb.com/de-ch/kontakt/',
            // Cancel renewal
            isCancelRenewalEnabled: true,
            isCancelrenewalSupportThroughEmail: false,
            cancelRenewalURL: 'https://www.dnb.com/de-ch/ueber-uns/kundenservice/',
            //  Recommended Products
            isRecommendedProductsEnabled: false,
            // Terms of Use
            termsOfUseURL: 'https://hello.dnb.com/rs/145-JUC-481/images/AGB_Dun-Bradstreet-Schweiz-AG_2021-07_DE.pdf',
            // Privacy Policy
            privacyPolicyURL: 'https://www.dnb.com/de-ch/datenschutz/',
            // Deals and offers
            isDealsOffersEnabled: false,
            // Recommended Service Section
            isRecommendedServiceEnabled: false,
            // My Business Overview Section only for CM UKI
            isBusinessOverviewEnabled: false,
            // Trust Centre link
            trustCentre: 'https://www.dnb.com/about-us/data-transparency.html',
        }
    }, {
        countryCode: 'SI',
        languagePreference: '',
        featuresList: {
            // Explore D&B tile
            isExploreDNBTileEnabled: true,
            exploreDNBTileURL: 'https://www.dnb.com/sl-si/produkti/dnb-finance-analytics/',
            // Market Place section
            isMarketPlaceSectionEnabled: false,
            marketPlaceSectionURL: '',
            // Company Details
            isAddCompanyCTAEnabled: true,
            addCompanyCTAURL: 'https://www.dnb.com/sl-si/kontakt/',
            isUpdatedInfoCTAEnabled: true,
            updatedInfoCTAURL: 'https://www.dnb.com/sl-si/kontakt/',
            isViewPublicProfileCTAEnabled: false,
            viewPublicProfileCTAURL: '',
            // Learning center
            isLearningCenterEnabled: false,
            learningCenterURL: '',
            // Support
            isSupportEnabled: true,
            supportURL: 'https://www.dnb.com/sl-si/kontakt/',
            // Cancel renewal
            isCancelRenewalEnabled: true,
            isCancelrenewalSupportThroughEmail: false,
            cancelRenewalURL: 'https://www.dnb.com/sl-si/kontakt/',
            //  Recommended Products
            isRecommendedProductsEnabled: false,
            // Terms of Use
            termsOfUseURL: 'https://www.dnb.com/sl-si/pravna-obvestila',
            // Privacy Policy
            privacyPolicyURL: 'https://www.dnb.com/sl-si/varovanje-osebnih-podatkov/',
            // Deals and offers
            isDealsOffersEnabled: false,
            // Recommended Service Section
            isRecommendedServiceEnabled: false,
            // My Business Overview Section only for CM UKI
            isBusinessOverviewEnabled: false,
            // Trust Centre link
            trustCentre: 'https://www.dnb.com/about-us/data-transparency.html',
        }
    }, {
        countryCode: 'SE',
        languagePreference: '',
        featuresList: {
            // Explore D&B tile
            isExploreDNBTileEnabled: true,
            exploreDNBTileURL: 'https://www.dnb.com/sv-se/smb.html',
            // Market Place section
            isMarketPlaceSectionEnabled: false,
            marketPlaceSectionURL: '',
            // Company Details
            isAddCompanyCTAEnabled: true,
            addCompanyCTAURL: 'https://service.dnb.com/sv-se/landing-page',
            isUpdatedInfoCTAEnabled: true,
            updatedInfoCTAURL: 'https://service.dnb.com/sv-se/landing-page',
            isViewPublicProfileCTAEnabled: false,
            viewPublicProfileCTAURL: '',
            // Learning center
            isLearningCenterEnabled: false,
            learningCenterURL: '',
            // Support
            isSupportEnabled: true,
            supportURL: 'https://service.dnb.com/sv-se/landing-page',
            // Cancel renewal
            isCancelRenewalEnabled: true,
            isCancelrenewalSupportThroughEmail: false,
            cancelRenewalURL: 'https://service.dnb.com/sv-se/landing-page',
            //  Recommended Products
            isRecommendedProductsEnabled: false,
            // Terms of Use
            termsOfUseURL: 'https://www.dnb.com/sv-se/legal.html', // needs to be updated
            // Privacy Policy
            privacyPolicyURL: 'https://www.dnb.com/sv-se/dataskydd/personuppgifter/behandlingar-i-sverige.html',
            // Deals and offers
            isDealsOffersEnabled: false,
            // Recommended Service Section
            isRecommendedServiceEnabled: false,
            // My Business Overview Section only for CM UKI
            isBusinessOverviewEnabled: false,
            // Trust Centre link
            trustCentre: 'https://www.dnb.com/about-us/data-transparency.html',
        }
    }, {
        countryCode: 'DK',
        languagePreference: '',
        featuresList: {
            // Explore D&B tile
            isExploreDNBTileEnabled: true,
            exploreDNBTileURL: 'https://www.dnb.com/da-dk/produkter-og-tjenester/risk-guardian-suite-kredittrapporter.html',
            // Market Place section
            isMarketPlaceSectionEnabled: false,
            marketPlaceSectionURL: '',
            // Company Details
            isAddCompanyCTAEnabled: true,
            addCompanyCTAURL: 'https://www.dnb.com/da-dk/kontakt.html',
            isUpdatedInfoCTAEnabled: true,
            updatedInfoCTAURL: 'https://www.dnb.com/da-dk/kontakt.html',
            isViewPublicProfileCTAEnabled: false,
            viewPublicProfileCTAURL: '',
            // Learning center
            isLearningCenterEnabled: false,
            learningCenterURL: '',
            // Support
            isSupportEnabled: true,
            supportURL: 'https://www.dnb.com/da-dk/kontakt.html',
            // Cancel renewal
            isCancelRenewalEnabled: true,
            isCancelrenewalSupportThroughEmail: false,
            cancelRenewalURL: 'https://www.dnb.com/da-dk/kontakt.html',
            //  Recommended Products
            isRecommendedProductsEnabled: false,
            // Terms of Use
            termsOfUseURL: 'https://www.dnb.com/da-dk/juridisk.html',
            // Privacy Policy
            privacyPolicyURL: 'https://www.dnb.com/da-dk/privatlivspolitik/privatpersoner.html',
            // Deals and offers
            isDealsOffersEnabled: false,
            // Recommended Service Section
            isRecommendedServiceEnabled: false,
            // My Business Overview Section only for CM UKI
            isBusinessOverviewEnabled: false,
            // Trust Centre link
            trustCentre: 'https://www.dnb.com/about-us/data-transparency.html',
        }
    }, {
        countryCode: 'NO',
        languagePreference: '',
        featuresList: {
            // Explore D&B tile
            isExploreDNBTileEnabled: true,
            exploreDNBTileURL: 'https://www.dnb.com/no/produkter-og-tjenester/bisnode-risk-guardian-suite-kredittrapporter.html',
            // Market Place section
            isMarketPlaceSectionEnabled: false,
            marketPlaceSectionURL: '',
            // Company Details
            isAddCompanyCTAEnabled: true,
            addCompanyCTAURL: 'https://www.dnb.com/no/kontakt/kundeservice-bedrift.html',
            isUpdatedInfoCTAEnabled: true,
            updatedInfoCTAURL: 'https://www.dnb.com/no/kontakt/kundeservice-bedrift.html',
            isViewPublicProfileCTAEnabled: false,
            viewPublicProfileCTAURL: '',
            // Learning center
            isLearningCenterEnabled: false,
            learningCenterURL: '',
            // Support
            isSupportEnabled: true,
            supportURL: 'https://www.dnb.com/no/kontakt/kundeservice-bedrift.html',
            // Cancel renewal
            isCancelRenewalEnabled: true,
            isCancelrenewalSupportThroughEmail: false,
            cancelRenewalURL: 'https://www.dnb.com/no/kontakt/kundeservice-bedrift.html',
            //  Recommended Products
            isRecommendedProductsEnabled: false,
            // Terms of Use
            termsOfUseURL: 'https://www.dnb.com/no/cookies.html',
            // Privacy Policy
            privacyPolicyURL: 'https://www.dnb.com/no/personvern-og-datasikkerhet/personvern-kunder.html',
            // Deals and offers
            isDealsOffersEnabled: false,
            // Recommended Service Section
            isRecommendedServiceEnabled: false,
            // My Business Overview Section only for CM UKI
            isBusinessOverviewEnabled: false,
            // Trust Centre link
            trustCentre: 'https://www.dnb.com/about-us/data-transparency.html',
        }
    }, {
        countryCode: 'FI',
        languagePreference: '',
        featuresList: {
            // Explore D&B tile
            isExploreDNBTileEnabled: true,
            exploreDNBTileURL: 'https://www.dnb.com/fi-fi/tuotteet/bisnode-risk-guardian.html',
            // Market Place section
            isMarketPlaceSectionEnabled: false,
            marketPlaceSectionURL: '',
            // Company Details
            isAddCompanyCTAEnabled: true,
            addCompanyCTAURL: 'https://www.dnb.com/fi-fi/yhteystiedot.html',
            isUpdatedInfoCTAEnabled: true,
            updatedInfoCTAURL: 'https://www.dnb.com/fi-fi/yhteystiedot.html',
            isViewPublicProfileCTAEnabled: false,
            viewPublicProfileCTAURL: '',
            // Learning center
            isLearningCenterEnabled: false,
            learningCenterURL: '',
            // Support
            isSupportEnabled: true,
            supportURL: 'https://www.dnb.com/fi-fi/yhteystiedot.html',
            // Cancel renewal
            isCancelRenewalEnabled: true,
            isCancelrenewalSupportThroughEmail: false,
            cancelRenewalURL: 'https://www.dnb.com/fi-fi/yhteystiedot.html',
            //  Recommended Products
            isRecommendedProductsEnabled: false,
            // Terms of Use
            termsOfUseURL: 'https://www.dnb.com/fi-fi/evasteet.html', // needs to be updated
            // Privacy Policy
            privacyPolicyURL: 'https://www.dnb.com/fi-fi/tietosuojaselosteet.html',
            // Deals and offers
            isDealsOffersEnabled: false,
            // Recommended Service Section
            isRecommendedServiceEnabled: false,
            // My Business Overview Section only for CM UKI
            isBusinessOverviewEnabled: false,
            // Trust Centre link
            trustCentre: 'https://www.dnb.com/about-us/data-transparency.html',
        }
    }

];
